import {productsOrderTableSettings} from '@/bps/components/productsOrderTable/productsOrderTableSettings';

productsOrderTableSettings.freeItemScrollOnSelect = true;

export {productsOrderTableSettings}
